import styled from "styled-components"

export const StyledFormMessage = styled.div`
  margin-top: ${({ theme }) => theme.space[1]};
  color: ${({ theme }) => theme.colors.black};
`
